import { useFetch } from '@/hooks/use-fetch'
import React, { HTMLAttributes } from 'react'
import { MdiGithub } from './icons'

type Props = HTMLAttributes<HTMLAnchorElement> & {
    repo: RepoType
}

const RepoCard = ({ repo, ...props }: Props) => {
    const formatDate = (dateString: string) => {
        const date = new Date(dateString)
        return date.toLocaleDateString('en-US', {
            year: 'numeric',
            month: 'short',
            day: 'numeric'
        })
    }

    return (
        <a
            href={repo.html_url}
            target="_blank"
            rel="noopener noreferrer"
            className="flex flex-col w-full group gap-y-1 p-6 rounded-lg border border-gray-200 hover:border-blue-500 transition-colors duration-200"
            {...props}
        >
            <div className="flex items-start justify-between">
                <h3 className="text-xl font-semibold text-white group-hover:text-blue-500">
                    {repo.name}
                </h3>
                <MdiGithub className="w-6 h-6 text-gray-500" />
            </div>

            {repo.description && (
                <p className="text-gray-300 line-clamp-2">
                    {repo.description}
                </p>
            )}

            <div className="flex flex-wrap gap-2">
                {repo.topics?.slice(0, 3).map((topic, index) => (
                    <span
                        key={index}
                        className="px-2 py-1 text-xs font-medium text-blue-600 bg-blue-100 rounded-full"
                    >
                        {topic}
                    </span>
                ))}
            </div>

            <div className="flex items-center gap-4 text-sm text-gray-500 max-sm:flex-wrap">
                {repo.language && (
                    <span className="flex items-center gap-1">
                        <span className="w-3 h-3 rounded-full bg-blue-500"></span>
                        {repo.language}
                    </span>
                )}
                <span className="flex items-center gap-1">
                    <svg className="w-4 h-4 text-amber-400" fill="currentColor" viewBox="0 0 20 20">
                        <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                    </svg>
                    {repo.stargazers_count}
                </span>
                <span className="flex items-center gap-1">
                    <svg className="w-4 h-4 text-green-500" fill="currentColor" viewBox="0 0 20 20">
                        <path d="M7.707 10.293a1 1 0 10-1.414 1.414l3 3a1 1 0 001.414 0l3-3a1 1 0 00-1.414-1.414L11 11.586V6h5a2 2 0 012 2v7a2 2 0 01-2 2H4a2 2 0 01-2-2V8a2 2 0 012-2h5v5.586l-1.293-1.293zM9 4a1 1 0 012 0v2H9V4z" />
                    </svg>
                    {repo.forks_count}
                </span>
                <span>Updated {formatDate(repo.updated_at)}</span>
            </div>
        </a>
    )
}

export default RepoCard